/**
 * Element stylu feature.
 */
enum StyleElement {
    /**
     * Základní tvar (bod, čára, polygon).
     */
    SHAPE = 'shape',

    /**
     * Marker generovaný pomocí parametru {@link StyleDefinition.marker}.
     */
    MARKER = 'marker',

    /**
     * Popisek generovaný pomocí parametru {@link StyleDefinition.labelSourceProperty}.
     */
    LABEL = 'label',
}

export default StyleElement;
